export default __webpack_public_path__ + "static/media/cover_big.2ae5eeab.jpg";